import React, { useEffect } from 'react';
import { HeaderSection } from '@components/Sections/HeaderSection/HeaderSection';
import { FooterSection } from '@components/Sections/FooterSection/FooterSection';
import { Outlet, useLocation } from 'react-router-dom';

export const RootLayout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <HeaderSection />
      <Outlet />
      <FooterSection />
    </>
  );
};
